import restaurant1 from "/soendrekyst/commercial-images/oesters-paa-fad-2.jpg"
import health1 from "/soendrekyst/commercial-images/yoga-klasse.jpg"
import bevaegelseshuset from "/soendrekyst/commercial-images/bevaegelseshuset.jpg"
import gaestebolig from "/soendrekyst/commercial-images/gaestebolig.jpg"
import pharmacy from "/soendrekyst/commercial-images/pharmacy.jpg"

const areaUnitdata = {
    "4": {
        "Erhverv": {
            "unit-1-restaurant": {
                Data: {
                    "headline": "Restaurant",
                    "description": "Restauranter direkte ud til havet er en sjældenhed i Danmark. I Gyldenløves restaurant kan du nyde en lækker middag i vandkanten med en ugenert udsigt til havet. Restaurantens store glasfoldedøre kan åbnes nærmest direkte ud i strandsandet. Den unikke placering leder tankerne hen på udlandets rivieraer og havnerestauranter, hvor gourmetoplevelser kan efterfølges af en slentretur langs havet, mens solen går ned over Køge by."
                }
            },
            "unit-2-health-club": {
                Data: {
                    "headline": "Health Club",
                    "description": "I Gyldenløves Health Club træder du ind i en verden af ro og velvære. En sand afslapning for sanserne i en travl hverdag, hvor selvforkælelse får lov at komme først. Her er der adgang til sauna, massørrum og fitnessredskaber. Den korte afstand til havet gør det oplagt at forene et friskt havdyp med en varm saunatur. Måske skal du være en del af vinterbadeklubben?"
                }
            }
        }
    },
    "6": {
        "Erhverv": {
            "unit-1-restaurant": {
                Data: {
                    "headline": "Restaurant",
                    "description": "Restauranter direkte ud til havet er en sjældenhed i Danmark. I Gyldenløves restaurant kan du nyde en lækker middag i vandkanten med en ugenert udsigt til havet. Restaurantens store glasfoldedøre kan åbnes nærmest direkte ud i strandsandet. Den unikke placering leder tankerne hen på udlandets rivieraer og havnerestauranter, hvor gourmetoplevelser kan efterfølges af en slentretur langs havet, mens solen går ned over Køge by.",
                    "gallery": [restaurant1]
                }
            },
            "unit-2-health-club": {
                Data: {
                    "headline": "Health Club",
                    "description": "I Gyldenløves Health Club træder du ind i en verden af ro og velvære. En sand afslapning for sanserne i en travl hverdag, hvor selvforkælelse får lov at komme først. Her er der adgang til sauna, massørrum og fitnessredskaber. Den korte afstand til havet gør det oplagt at forene et friskt havdyp med en varm saunatur. Måske skal du være en del af vinterbadeklubben?",
                    "gallery": [health1]
                }
            }
        }
    },
    "10": {
        "Erhverv": {
            "Unit-3-Sundhedshus": {
                Data: {
                    "headline": "Sundhedshus",
                    "description": "",
                    "gallery": []
                }
            },
            "Unit-1-Kiosk": {
                Data: {
                    "headline": "Apotek",
                    "description": "På det nordvestlige hjørne af Hvide Falk ligger et apotek, hvor du kan købe receptpligtig medicin, håndkøbsmedicin og solcreme til strandturen. Det er altid rart at have et apotek tæt på, når du pludselig står og mangler plaster, allergimedicin eller noget mod forkølelse.",
                    "gallery": [pharmacy]
                }
            }
        },
        "Byfaellesskab": {
            "Unit-4-Gæsteværelse": {
                Data: {
                    "headline": "Gæsteværelse",
                    "description": "Får du gæster langvejs fra? Hvis du får besøg langvejsfra, eller hvis middagen bliver lidt for hyggelig ud på de sene timer, kan du booke en gæstebolig til dine gæster. Søndre Kyst får i alt ni gæsteboliger med eget bad og toilet fordelt på de seks karréer. Du kan booke op til fire overnatninger, fordelt på én eller flere  gæsteboliger. Efter den sidste overnatning, går der 14 dage før du igen kan booke op til fire overnatninger. Man kan maksimalt booke 3 måneder forud. Der kan ikke ske  refundering ved afmelding. Er der ledige gæsteboliger, når der er under 24 timer til  lejestart, kan alle beboere booke disse. Gæsteboligerne har dyner og hovedpuder, men gæsterne skal selv medbringe lagener, sengetøj og håndklæder.  I skal selv gøre rent efter endt ophold, så I efterlader  gæsteboligerne lige så pænt, som da I ankom. Ellers bliver der pålagt et gebyr på 1.200 kr. til beboeren til betaling af  ekstern rengøring. Der vil være mulighed for gæsteparkering i p-kælder, hvor der via parkeringsapp kan  købes dagsbillet til en reduceret pris.",
                    "gallery": [gaestebolig]
                }
            },
            "Unit-2-Bevægelseshus": {
                Data: {
                    "headline": "Bevægelseshus",
                    "description": "MØD NABOEN TIL YOGA ELLER ZUMBARYTMER Leg, dans og bevægelse er fantastiske aktiviteter til at lade op på fra morgenstunden eller efter en travl dag eller uge. Søndre Kysts Bevægelseshus er en idéel ramme til yogahold, sjove danselektioner eller andet, der får pulsen op. På Søndre Kyst er der rig mulighed for et aktivt udendørsliv med kajakroning, paddleboard, løb i naturen eller vinterbadning, men det skal også være muligt at have et aktivt liv indendørs. Lokalet på 140 kvadratmeter, svarende til en badmintonbane, kan lejes til yogahold, zumbatimer eller andre idrætsformer. Bevægelseshuset er drevet af frivillige sjæle. Måske vil I hyre en underviser, eller måske er der en beboer, der er uddannet instruktør, som vil sætte struktur på dagens eller aftenens program. Der er også mulighed for barsels- eller seniorgymnastik i dagtimerne. I fællesskab findes løsninger, så flest mulig får glæde af lokalet, og så der kommer et økonomisk overtilskud til driften af Byfællesskabet.",
                    "gallery": [bevaegelseshuset]
                }
            }
        }
    },
}

export default areaUnitdata